<div class="group" *ngIf="fields?.length">
  <div class="title" *ngIf="group.title">{{group.title}}</div>
  <div class="fields">
    <filter-field [formGroup]="formGroup" [field]="field" *ngFor="let field of fields"></filter-field>
  </div>
</div>
